import { render } from "./FooterComponent.vue?vue&type=template&id=539f443d"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=539f443d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__